module.exports = __webpack_public_path__ + "img/1958_horizontal.6d84b0a5.svg";